import styled from 'styled-components';
import { medias } from 'assets/styled/tokens';

export const AdsContainer = styled.div`
  box-shadow: 0px 1px 8px 0px #0000001a;
  background: #ffffff;
  flex: 1;
  height: 532px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  padding: 12px 24px 24px 24px;
  margin-left: 24px;

  @media screen and (max-width: ${medias.tablet}) {
    width: 100%;
    padding: 16px;
    margin-left: 0;
    justify-content: flex-start;
    height: auto;
  }

  @media screen and (max-width: ${medias.desktopMd}) {
    height: auto;
    flex: 1;
    width: 100%;
    margin-left: 0;
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  height: auto;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  @media screen and (max-width: ${medias.tablet}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  h1 {
    font-family: Blinker;
    font-size: 32px;
    font-weight: 700;
    line-height: 36px;
    letter-spacing: 0.5px;
    text-align: left;
  }
`;

export const SocialMediaIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media screen and (max-width: ${medias.tablet}) {
    width: 100%;
    justify-content: space-between;
  }
  h2 {
    font-family: Roboto;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.3px;
    text-align: left;
    color: #888888;
    margin-right: 16px;
  }
  div svg:hover {
    cursor: pointer;
  }
`;

export const SocialLinksContainer = styled.div`
  display: flex;
  gap: 8px;

  @media screen and (max-width: ${medias.tablet}) {
    gap: 19px;
    margin-left: auto;
  }
`;
